import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
    root: {
        width: '1rem',
        marginBottom: 0,
        border: 'none' as const,
        fontSize: '22px',
        cursor: 'pointer' as const
    }
}));